// extracted by mini-css-extract-plugin
module.exports = {"cursor":"ReloveIconProtection_cursor__H1E3T","root":"ReloveIconProtection_root__JkAUO"};